import { render, staticRenderFns } from "./TriggersRTA.vue?vue&type=template&id=360a54a6&scoped=true&"
import script from "./TriggersRTA.vue?vue&type=script&lang=js&"
export * from "./TriggersRTA.vue?vue&type=script&lang=js&"
import style0 from "./TriggersRTA.vue?vue&type=style&index=0&id=360a54a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a54a6",
  null
  
)

export default component.exports